module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/chefs_choice--xxl@2x-24cc95c5640accf8fc3a742381599409.png";